<div class="card">
<div class="card-body">
    <div class="chart-container skill-chart">
      <div id="circlechart">
        <apx-chart
          [chart]="childStatus.chart"
          [plotOptions]="childStatus.plotOptions"
          [series]="childStatus.series"
          [labels]="childStatus.labels"
          [legend]="childStatus.legend"
          [colors]="childStatus.colors"
          [responsive]="childStatus.responsive"
        ></apx-chart>
      </div>
    </div>
  </div>
</div>